import { Chip } from '@/shared/ui/components';
import { formatC1cDeviceLabel } from '@/shared/lib';
import classNames from 'classnames';

interface C1cDeviceLabelProps {
  deviceType?: string | null;
  className?: string;
}

/**
 * Chip naming the CardioOne-supplied device family next to a device ID. Renders nothing for any other device type.
 *
 * @param deviceType - Study-level device type.
 * @param className - Extra class for the chip, for spacing inside the caller's row.
 * @returns The chip for LifeSignals and VivaLNK, otherwise null.
 */
const C1cDeviceLabel = ({ deviceType, className }: C1cDeviceLabelProps) => {
  const label = formatC1cDeviceLabel(deviceType);
  if (!label) {
    return null;
  }
  return (
    <Chip
      size="small"
      style={{
        border: 0,
        paddingInline: 6,
        fontWeight: 700,
        lineHeight: '16px',
        letterSpacing: 0.1,
      }}
      background="#5F2DD6"
      color="#FFFFFF"
      closable={false}
      className={classNames('c1c-device-label', className)}
    >
      {label}
    </Chip>
  );
};

export default C1cDeviceLabel;
export type { C1cDeviceLabelProps };
